module.exports = __webpack_public_path__ + "45bfb09a1cb363013526b1963c81fa94.png";